/** Special grant value meaning a subscription unlocks every feature key. */
export const ALL_FEATURES = 'subscription_all';
//# sourceMappingURL=types.js.map